import { analytics, logEvent } from "../firebase";

export const gaCustomEvent = (eventName, buttonClickName, customerId) => {
  if(!analytics) {
    console.warn("Analytics is not initialized.");
    return;
  }

  try {
    logEvent(analytics, eventName, {
      buttonName: buttonClickName,
      app_customer_id: customerId,
      debug_mode: true, // enable debug mode for UAT testing
    });
  } catch (error) {
    console.error("Error logging custom event:", error);
  }
};